export default `id class num notes
k1 Const 1.2 "some parameter"
`;
